import React from 'react';
import Button from "semantic-ui-react/dist/es/elements/Button/Button.js";
import { Icon, ICON_NAMES } from "../../Icon";
export var nextItem = React.createElement(Button, {
  circular: true,
  content: null
}, React.createElement(Icon, {
  isColorInverted: true,
  name: ICON_NAMES.CHEVRON_RIGHT
}));
export var previousItem = React.createElement(Button, {
  circular: true,
  content: null
}, React.createElement(Icon, {
  isColorInverted: true,
  name: ICON_NAMES.CHEVRON_LEFT
}));
export var nextItemOutlined = React.createElement(Button, {
  basic: true,
  circular: true,
  className: "has-outline",
  content: null
}, React.createElement(Icon, {
  name: ICON_NAMES.CHEVRON_RIGHT
}));
export var previousItemOutlined = React.createElement(Button, {
  basic: true,
  circular: true,
  className: "has-outline",
  content: null
}, React.createElement(Icon, {
  name: ICON_NAMES.CHEVRON_LEFT
}));